export default __webpack_public_path__ + "static/3-5fb160df3b2bba4f4785f426ba1933dc.png";